import React from "react";

function More() {
  return <h1 className="more">More</h1>;
}

export default More;
